/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SharedBottomModule_bottomModule = ReadonlyArray<{
    readonly " $fragmentRefs": FragmentRefs<"SharedBottomModuleContent_bottomModule">;
    readonly " $refType": "SharedBottomModule_bottomModule";
}>;
export type SharedBottomModule_bottomModule$data = SharedBottomModule_bottomModule;
export type SharedBottomModule_bottomModule$key = ReadonlyArray<{
    readonly " $data"?: SharedBottomModule_bottomModule$data;
    readonly " $fragmentRefs": FragmentRefs<"SharedBottomModule_bottomModule">;
}>;



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "SharedBottomModule_bottomModule",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedBottomModuleContent_bottomModule"
    }
  ],
  "type": "BottomModule",
  "abstractKey": null
};
(node as any).hash = '4376bd5e251ec51431d36d8ac0677f78';
export default node;
